<template>
  <div class="expert-category-select">
    <a-select size="large" mode="multiple"  placeholder="请选择专业特长" :value="selectedValues" @change="handleChange"
      style="width: 100%" :maxTagCount="5">
      
      <!-- 扁平化选项用于回显 -->
      <a-select-option v-for="opt in allOptions" :key="opt.value" :value="opt.value">
        {{ opt.label }}
      </a-select-option>

      <!-- 自定义下拉内容 -->
      <div slot="dropdownRender" slot-scope="menu">
        <div class="custom-dropdown-content" @mousedown.prevent>
          <div v-for="group in groups" :key="group.key" class="custom-group">
            <div class="group-title" @click="toggleGroup(group.key)">
              <span class="expand-icon">
                <a-icon :type="expandedGroups.includes(group.key) ? 'down' : 'right'" />
              </span>
              {{ group.name }}
            </div>
            <div class="group-options" v-show="expandedGroups.includes(group.key)">
              <div 
                v-for="opt in group.options" 
                :key="opt.value" 
                class="custom-option-item"
                :class="{
                  'selected': selectedValues.includes(opt.value)
                }"
                @click="handleOptionClick(group.key, opt)"
              >
                <div class="option-header">
                  <span class="option-label">{{ opt.label }}</span>
                  <a-icon v-if="selectedValues.includes(opt.value)" type="check" class="check-icon" />
                </div>
                <div class="option-desc" v-if="opt.description">
                  {{ opt.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-select>
    <div class="helper-text" v-if="selectionMode === 'multiple' && (min > 0 || max > 0)">
      <span v-if="min > 0">最少选{{min}}项</span>
      <span v-if="min > 0 && max > 0">，</span>
      <span v-if="max > 0">最多选{{max}}项</span>
    </div>
  </div>
</template>

<script>
import { getExpertCategorys } from "@/api/common.js";

export default {
  name: "ExpertCategorySelect",
  props: {
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectionMode: {
      type: String,
      default: 'multiple',
      validator: value => ['single', 'multiple'].includes(value)
    },
    max: {
      type: [Number, String],
      default: 0 // 0 means no limit
    },
    min: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      groups: [],
      expandedGroups: [], // 存储已展开的组 key
    };
  },
  computed: {
    // Flatten the object into a single array for the select component
    selectedValues() {
      if (!Array.isArray(this.value)) {
        return []
      }
      return this.value.map(item => item.id)
    },
    // 所有选项扁平化，供 a-select-option 使用
    allOptions() {
      return this.groups.reduce((acc, group) => {
        const optionsWithParentName = (group.options || []).map(opt => ({
          ...opt,
          label: `${group.name} - ${opt.label}`
        }));
        return acc.concat(optionsWithParentName);
      }, []);
    }
  },
  created() {
    this.loadExpertCategorys();
  },
  methods: {
    loadExpertCategorys() {
      getExpertCategorys().then(res => {
        if (res && res.length > 0) {
          this.groups = res.map(group => ({
            key: group.id,
            name: group.categoryName,
            options: (group.childs || []).map(child => ({
              label: child.categoryName,
              value: child.id,
              parentId: child.parentId,
              description: child.des||'',
            }))
          }))
          if (this.groups.length > 0) {
            this.expandedGroups = [this.groups[0].key];
          }
        }
      });
    },
    toggleGroup(key) {
      const index = this.expandedGroups.indexOf(key);
      if (index > -1) {
        this.expandedGroups.splice(index, 1);
      } else {
        this.expandedGroups.push(key);
      }
    },
    handleOptionClick(groupKey, opt) {
      const value = opt.value;
      const index = this.selectedValues.indexOf(value);
      let newValues = [];
      
      if (this.selectionMode === 'single') {
        newValues = [value];
      } else {
        newValues = [...this.selectedValues];
        if (index > -1) {
          newValues.splice(index, 1);
        } else {
          if (this.max > 0 && newValues.length >= this.max) {
            this.$message.warning(`最多只能选择${this.max}项`);
            return;
          }
          newValues.push(value);
        }
      }
      
      this.handleChange(newValues);
    },
    handleChange(values) {
      const result = []
      values.forEach(val => {
        for (const group of this.groups) {
          const option = group.options.find(opt => opt.value === val)
          if (option) {
            result.push({
              id: option.value,
              parentId: option.parentId,
              name: option.label,
              parentName: group.name
            })
            break
          }
        }
      })
      this.$emit("input", result);
      this.$emit("change", result);
    },
  },
};
</script>
<style lang="less" scoped>
.expert-category-select {
  width: 100%;
}
.helper-text {
  margin-top: 8px;
  color: #999;
  font-size: 12px;
}
.custom-dropdown-content {
  padding: 8px 0;
  max-height: 300px;
  overflow-y: auto;
}
.custom-group {
  padding: 0 12px;
  margin-bottom: 8px;
  
  .group-title {
    color: #333;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
    padding: 8px;
    background-color: #fafafa;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: background-color 0.3s;
    
    &:hover {
      background-color: #f0f0f0;
    }
    
    .expand-icon {
      margin-right: 8px;
      font-size: 12px;
      color: #999;
      width: 16px;
      text-align: center;
    }
  }
  
  .group-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
}
.custom-option-item {
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #f5f5f5;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  
  &:hover {
    background-color: #e6f7ff;
    
    .option-header {
      color: #1890ff;
    }
  }
  
  &.selected {
    background-color: #e6f7ff;
    
    .option-header {
      color: #1890ff;
      font-weight: 500;
    }
  }
  
  &.disabled {
    color: #00000040;
    background-color: #f5f5f5;
    cursor: not-allowed;
    
    .option-header {
       color: #00000040;
    }
    
    &:hover {
      color: #00000040;
      background-color: #f5f5f5;
    }
  }
  
  .option-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .check-icon {
    font-size: 12px;
  }
  
  .option-desc {
    font-size: 12px;
    color: #999;
    line-height: 1.5;
    word-break: break-all;
    white-space: pre-wrap;
  }
}
</style>
